<template>
  <div class="visit">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="报备成功" name="sucess">
        <template v-if="activeName == 'sucess'">
          <sucessLogs />
        </template>
      </el-tab-pane>
      <el-tab-pane label="报备失败" name="failure">
        <template v-if="activeName == 'failure'">
          <failureLogs />
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import sucessLogs from './sucess';
import failureLogs from './failure';

export default {
  components: {
    sucessLogs,
    failureLogs,
  },
  data() {
    return {
      activeName: this.$route.query.channel || 'sucess',
    };
  },
  created() {
    // console.log('channel', this.$route.channel);
  },

  computed: {},

  watch: {},
  methods: {
    handleClick(tab) {
      // console.log(tab.name);
      this.$router.push({
        path: '/home/user/visit',
        query: {
          channel: tab.name,
        },
      });
    },
  },
};
</script>
